module.exports = __webpack_public_path__ + "img/7-6.9275abac.png";